
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import { AgentResource,  AgentAccessorialChargeTypeResource} from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";
import router from "@/router";

import { AgentFacilityResourceSelect} from "../../../models/ui/manageAgent";


const systemModule = getModule(SystemModule);




@Component
export default class ManageAccessorialCharges extends Vue {
  @Prop()
  agent:AgentResource;
    
  @Prop()
  public agentAccessorialChargeTypes:Array<AgentAccessorialChargeTypeResource>;

  filterString:string ='';

  loading: boolean = false;
  loadingPage: boolean = false;
  
  
  agentAccessorialChargeType: AgentAccessorialChargeTypeResource = {
    id: null,
    agentId: null,
    code: null,
    description: null,
    isActive: true
  };

  isChargeTypeModalVisible: boolean = false;
  isDeleteChargeTypeModalVisible: boolean = false;

  
  async addAgentChargeType() {
    this.agentAccessorialChargeType = {
      id: null,
      agentId: this.agent.id,
      code: null,
      description: null,
      isActive: true
    };

    this.isChargeTypeModalVisible = true;
  }

  async editAgentChargeType(id: number) {
    let clone = this.agentAccessorialChargeTypes.find(x => x.id === id);
    clone = { ...clone };

    this.agentAccessorialChargeType = clone;
    this.isChargeTypeModalVisible = true;
  }
  
  showAgentChargeTypeDeleteConfirmation(id: number) {
    let clone = this.agentAccessorialChargeTypes.find(x => x.id === id);
    clone = { ...clone };

    this.agentAccessorialChargeType = clone;
    this.isDeleteChargeTypeModalVisible = true;
  }

  async saveAgentChargeType() {
    this.agentAccessorialChargeType.agentId = this.agent.id;
    if (this.agentAccessorialChargeType.id === null) {
      await systemModule.postAgentAccessorialChargeType(this.agentAccessorialChargeType);
    } else {
      await systemModule.putAgentAccessorialChargeType(this.agentAccessorialChargeType);
    }
    this.$emit("updated");
  }

  async deleteAgentChargeType() {
    try {
      await systemModule.deleteAgentAccessorialChargeTypee(this.agentAccessorialChargeType.id);
      notifications.success("Success", `Charge type deleted.`);      
    } catch (error) {
      notifications.error('Delete Failed','Unable to delete charge type.', error);      
    }
    this.$emit("updated");
  }
 
}
